<template>
  <div class="bg-gray-100">
    <CContainer class="min-vh-100 table-container mt-5">
      <CCard>
        <CCardBody>
          <div v-if="isLoading" class="d-flex justify-content-center">
            <CSpinner style="width: 1.5rem; height: 1.5rem" color="primary" />
          </div>
          <div v-else>
            <div v-if="!hasRedirectStatus" class="d-flex flex-column align-items-center">
              <img src="/img/site/amico.png" width="181" />
              <span class="font-xl my-4 text-black text-center">{{ $t('payment.confirmation.3ds.title') }}</span>
              <div>
                <CButton class="px-5 py-2" color="primary" @click="confirmPayment">{{ $t('payment.confirmation.3ds.confirm') }}</CButton>
              </div>
            </div>
            <div v-if="isSucceded" class="d-flex flex-column align-items-center">
              <img src="/img/site/modal-success-payment.png" width="181" />
              <span class="font-xl my-4 text-black text-center">{{ $t('payment.confirmation.3ds.success') }}</span>
              <div>
                <CButton class="px-5 py-2" color="primary" @click="redirectToHome">{{ $t('payment.confirmation.3ds.back') }}</CButton>
              </div>
            </div>
            <div v-if="isFailed" class="d-flex flex-column align-items-center">
              <CIcon name="refusedFull" class="text-danger" size="custom-size" :height="100" viewBox="0 0 32 32" />
              <span class="font-xl my-4 text-black text-center">{{ $t('payment.confirmation.3ds.fail') }}</span>
              <div>
                <CButton class="px-5 py-2" color="primary" @click="redirectToHome">{{ $t('payment.confirmation.3ds.back') }}</CButton>
              </div>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
import services from '../../services'

export default {
  name: 'PaymentConfirmation3ds',
  data() {
    return {
      stripe: null,
      elements: null,
      appearance: {
        theme: 'stripe',
        rules: {
          '.Label': {
            fontSize: '1rem',
            fontWeight: 'semibold',
          },
        },
        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Nunito Sans, system-ui, sans-serif',
          spacingUnit: '6px',
          borderRadius: '4px',
        },
      },
      clientSecret: undefined,
      isLoading: false,
      isSucceded: false,
      isFailed: false,
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    },
    paymentId() {
      return this.$route.query.paymentId
    },
    organizationId() {
      return this.$route.params.organizationId
    },
    hasRedirectStatus() {
      return Boolean(this.$route.query.redirect_status)
    },
  },
  mounted() {
    this.initStripe()
    if (this.hasRedirectStatus) {
      this.handleRedirectStatus()
    } else {
      this.getPaymentClientSecret()
    }
  },
  methods: {
    initStripe() {
      this.stripe = window.Stripe(this.$configs.VUE_APP_STRIPE_PK, {
        locale: this.lang.split('-')[0],
      })
    },
    async getPaymentClientSecret() {
      try {
        this.isLoading = true
        const response = await services.getPaymentIdClientSecret(this.organizationId, this.paymentId)

        this.clientSecret = response.data.data.clientSecret
      } catch (error) {
        this.$router.push({ name: 'notFound', params: { organizationId: this.organizationId } })
      } finally {
        this.isLoading = false
      }
    },
    handleRedirectStatus() {
      const queryParams = this.$route.query

      if (queryParams.redirect_status === 'succeeded') {
        this.isSucceded = true
        return
      }

      this.isFailed = true
    },
    confirmPayment() {
      try {
        this.isLoading = true
        const returnUrl = `${window.location.origin}${
          this.$router.resolve({
            name: 'paymentConfirmation3ds',
            params: { organizationId: this.organizationId, paymentId: this.paymentId },
          }).href
        }`

        this.stripe.confirmPayment({
          clientSecret: this.clientSecret,
          confirmParams: {
            return_url: returnUrl,
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    redirectToHome() {
      this.$router.push({ name: 'home', params: { organizationId: this.organizationId } })
    },
  },
  watch: {
    lang(newValue) {
      if (!this.elements) return

      this.card = this.elements.update({ locale: newValue.split('-')[0] })
    },
  },
}
</script>

<style lang="scss" scoped>
.table-container {
  max-width: 770px;
}
</style>
